<template>
  <button id="KEY_A" name="A" class="btn softkey-btn" aria-label="A" data-vcode="COLOR_KEY_0">
    <img src="/images/icn-softkey-A.svg" alt="" role="img" aria-hidden="true" />
  </button>
</template>
<script>
export default {};
</script>
